import api from '.'
import {
	PackConvert,
	ReviewedPackConversion,
	ReviewedPackConversionsReq,
	UpdatePackConversionRequest,
	UpdateReviewedPackConversionRequest,
} from './packConverts.types'

// Query Key factory
export const PackConvertKeys = {
	all: ['pack-converts'],
	list: (basketId: Id) => [...PackConvertKeys.all, basketId],
	reviewedCount: () => [...PackConvertKeys.all, 'count'],
	reviewedList: (query: ReviewedPackConversionsReq) => [...PackConvertKeys.all, query],
	reviewedDetail: (id: Id) => [...PackConvertKeys.all, 'detail', id],
}

const PackConvertApi = {
	// Pack conversion endpoints for the Action Center
	list: (basketId: Id, page = 1) =>
		api
			.get<PaginatedAPIRes<PackConvert[]>>(`/market-baskets/${basketId}/pack-conversions`, {
				params: { page },
			})
			.then((res) => res.data),
	update: (basketId: Id, request: UpdatePackConversionRequest) =>
		api.post(`/market-baskets/${basketId}/pack-conversions`, request),

	// Reviewed pack conversion endpoints
	reviewedCount: () =>
		api.get<APIRes<number>>('/market-baskets/pack-conversions/count').then((res) => res.data.data),
	reviewedList: (query: ReviewedPackConversionsReq) =>
		api
			.get<PaginatedAPIRes<ReviewedPackConversion[]>>('/market-baskets/pack-conversions', {
				params: query,
			})
			.then((res) => res.data),
	reviewedDetail: (id: Id) =>
		api
			.get<APIRes<ReviewedPackConversion>>(`/market-baskets/pack-conversions/${id}`)
			.then((res) => res.data.data),
	delete: (id: Id) => api.delete('/market-baskets/pack-conversions', { data: { id } }),
	updateReviewed: (id: Id, request: UpdateReviewedPackConversionRequest) =>
		api.patch(`/market-baskets/pack-conversions/${id}`, request),
}

export default PackConvertApi
